/**
 * Formats reading time with localization support
 * @param readingTime - Can be a number (minutes) or a string like "4 min read" or "4"
 * @param t - Translation function from next-intl (can be from useTranslations or getTranslations)
 * @returns Formatted reading time string
 */
export function formatReadingTime(
  readingTime: string | number | undefined,
  t: (key: string, options?: any) => string
): string | undefined {
  if (!readingTime) return undefined;

  let minutes: number;

  // If it's already a number, use it directly
  if (typeof readingTime === "number") {
    minutes = readingTime;
  } else {
    // Extract number from string like "4 min read" or "4"
    const match = readingTime.match(/\d+/);
    if (!match) return readingTime; // Return as-is if no number found
    minutes = parseInt(match[0], 10);
  }

  // Use appropriate translation key
  // Try with namespace first, then fallback to direct key
  try {
    const translationKey = minutes === 1 ? "reading_time.min" : "reading_time.mins";
    return `${minutes} ${t(translationKey)}`;
  } catch {
    // Fallback if translation fails
    return `${minutes} min read`;
  }
}

